<template>
  <v-card outlined class="rounded-xl">
    <v-card-title class="text-subtitle-2 font-weight-bold text-truncate d-inline-block py-4 d-flex flex-row align-center">
      Дополнительные единицы измерения
      <v-spacer/>
      <v-icon :color="$store.state.achievement.side_color">
        fa fa-question-circle
      </v-icon>
    </v-card-title>
    <v-divider/>
    <v-card-text>
      <v-slide-y-transition
          class="py-0"
          tag="div"
          style="width: 100%"
          group
          leave-absolute
      >
        <div v-for="(subunit, i) in achievementKindSubunits" :key="keyVForSubunit(subunit)">
          <subunit-level-text-field :subunit="subunit" :index-unit="indexUnit" :index-subunit="i" :unit-id="unit.id"/>
        </div>
      </v-slide-y-transition>
      <add-card :body_text="'Добавить дополнительные ед. измерения'"
                :min_height="'44px'"
                class="mt-3"
                @add="pushSubunit(indexUnit)"/>
    </v-card-text>
  </v-card>
</template>

<script>
import {mapMutations, mapState} from "vuex";
import AddCard from "../../Cards/AddCard";
import SubunitLevelTextField from "../FormAdminAchievementKind/SubunitLevelTextField";

export default {
  name: "SectionEditSubunit",

  components: {
    AddCard,
    SubunitLevelTextField,
  },

  props: {
    unit: Object,
    unitKey: String,
    indexUnit: Number,
  },

  data() {
    return {
      rules_level_points_text: [
        (v) => !!v || "Это поле обязательно к заполнению",
        // (v) => v.length < 4 || "Допускаются только 3 символа",
      ]
    }
  },

  computed: {
    achievementKindSubunits() {
      const subunits = this.unit.prtf_achievement_subunits_attributes;

      return _.filter(subunits, (subunit)=> !_.has(subunit,"_destroy"));
    },
  },

  methods: {
    ...mapMutations({
      pushSubunit: 'achievement_kind/pushSubunit',
    }),

    keyVForSubunit(subunit) {
      if (_.isUndefined(subunit?._index)) return subunit.id
      else return subunit?._index
    },

  }
}
</script>

<style scoped>

</style>